import React from "react"

function Medal({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1698 15.9354L11.3428 13.5419V6.92188H24.9559V13.5324L19.1419 15.9179"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8153 9.32422V12.5766"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3794 9.32422V12.5766"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0973 28.5239C20.8084 28.5239 23.0062 26.3261 23.0062 23.615C23.0062 20.9039 20.8084 18.7061 18.0973 18.7061C15.3862 18.7061 13.1884 20.9039 13.1884 23.615C13.1884 26.3261 15.3862 28.5239 18.0973 28.5239Z"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4663 21.3986C16.8997 20.9323 15.102 22.311 15.4024 24.3343"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Medal
